"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CanvasElement = (function () {
    function CanvasElement(id) {
        this.element = document.getElementById(id);
    }
    CanvasElement.prototype.width = function (percent) {
        return this.element.width / 100 * percent;
    };
    CanvasElement.prototype.height = function (percent) {
        return this.element.height / 100 * percent;
    };
    CanvasElement.prototype.getElement = function () {
        return this.element;
    };
    return CanvasElement;
}());
exports.default = CanvasElement;



//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/ts/coin-animation/canvas-element.ts
// module id = 343
// module chunks = 4